import { render, staticRenderFns } from "./NewResourceDialog.vue?vue&type=template&id=7b9db7b5&scoped=true"
import script from "./NewResourceDialog.vue?vue&type=script&lang=js"
export * from "./NewResourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9db7b5",
  null
  
)

export default component.exports